import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import VueYouTubeEmbed from 'vue-youtube-embed'
import firebase from "firebase/app";
import "firebase/firestore";

Vue.use(VueYouTubeEmbed)
Vue.config.productionTip = false

const firebaseConfig = {
  apiKey: "AIzaSyCFuaWC3L2V-QF2BMuCd_sD0QWkR31WeCk",
  authDomain: "concord-dentist.firebaseapp.com",
  projectId: "concord-dentist",
  storageBucket: "concord-dentist.appspot.com",
  messagingSenderId: "346472986176",
  appId: "1:346472986176:web:285ab99edb8d0533ced1a5"
};

const app = !firebase.apps.length ? firebase.initializeApp(firebaseConfig) : firebase.app();
export const db = app.firestore();

new Vue({
  vuetify,
  render: h => h(App)
}).$mount('#app')
